import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Enables swipe-from-left-edge to navigate back on mobile.
 * Threshold: ≥80 px horizontal, ≤40 px vertical, completed within 400 ms.
 */
export function useSwipeBack(enabled = true) {
  const navigate = useNavigate();
  const touchRef = useRef<{ x: number; y: number; t: number } | null>(null);

  useEffect(() => {
    if (!enabled || !("ontouchstart" in window)) return;

    function onTouchStart(e: TouchEvent) {
      const touch = e.touches[0];
      if (!touch) return;
      if (touch.clientX < 24) {
        touchRef.current = { x: touch.clientX, y: touch.clientY, t: Date.now() };
      }
    }

    function onTouchEnd(e: TouchEvent) {
      const start = touchRef.current;
      if (!start) return;
      touchRef.current = null;

      const touch = e.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - start.x;
      const dy = Math.abs(touch.clientY - start.y);
      const dt = Date.now() - start.t;

      if (dx >= 80 && dy <= 40 && dt < 400) {
        navigate(-1);
      }
    }

    document.addEventListener("touchstart", onTouchStart, { passive: true });
    document.addEventListener("touchend", onTouchEnd, { passive: true });
    return () => {
      document.removeEventListener("touchstart", onTouchStart);
      document.removeEventListener("touchend", onTouchEnd);
    };
  }, [enabled, navigate]);
}
